import styled from "vue-styled-components";

export const CreateCompanyContent = styled.div`
  & .hide {
    display: none;
  }
  & .panel-content {
    display: flex;
    flex-direction: row;
    & .left-panel {
      position: sticky;
      top: 100;
      display: flex;
      flex-direction: column;
      align-items: center;
      & .image-company {
        background-color: #cccccc;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        width: 250px;
        height: 250px;
        border-radius: 5px;
      }
    }
    & .right-panel {
      padding-left: 20px;
    }
  }
  .btn-save {
    display: flex;
    margin: 0 auto;
    width: 30%;
    justify-content: center;
  }
  .label {
    font-size: 1em;
  }
  .header-modal {
    background-color: #2962ff;
  }
  .modal-button-custom {
    padding: 5px;
    width: 35px;
    height: 35px;
    border-radius: 20px;
    margin-top: 25px;
  }
  .button-group {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 1.5em;
  }
  .buttons .button:not(:last-child):not(.is-fullwidth) {
    margin-right: 0.1rem !important;
  }
  & .widget {
    box-shadow: 0px 0px 1px #000000;
    background-color: #ffffff;
    padding: 10px 15px;
    border-radius: 5px;
    & .widget-body {
      margin-top: 15px;
    }
    & .description {
      color: #333333;
      margin: 0;
    }
    & .item-widget {
      position: relative;
      padding: 15px;
      border: 1px solid #efefef;
      background-color: #f9f9f9;
      cursor: pointer;
      border-radius: 5px;
      &.selected {
        background-color: #c1d6ff;
        border: 1px solid #88b1ff;
      }
      & .item-title {
        margin: 0;
      }
      & .item-description {
        margin: 0;
        padding: 0;
      }
      & .btn-float {
        position: absolute;
        top: 5px;
        right: 0;
        border: 0;
        width: 35px;
        height: 35px;
        font-size: 20px;
        padding: 0;
        color: #333333;
        background-color: transparent;
        border-radius: 100%;
        opacity: 0.5;         
        &.btn-edit {
          background-color: #2962ff;
          margin-right: 35px;
          color: #ffffff;
          opacity: 1;
          &:hover {
            background-color: #002ca7;
          }
        }
        &:hover {
          opacity: 1;
        }
        &:active{
          opacity: 0.5;
        }        
      }
    }
  }
  .includeIcon {
    float: unset !important;
  }
  & .check-digit-container {
    display: flex;
    & .input-default {
      width: 100%;
    }
    & .digit {
      min-width: 100px;
      width: 20%;
    }
  }
`;
